import type { Language } from "./Language"
import { allLanguages } from "./Language"

export function isLanguage(language?: unknown): language is Language {
	return language !== undefined && typeof language === "string" && allLanguages.includes(language as Language)
}
